import React, { useEffect, useState } from "react";
import { Input, Modal } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import { useGetTemplateFields } from "~/entity/Template";
import { TemplateFieldsIProps } from "~/entity/Template/model/schema";
import { formaterData } from "~/pages/Editor/ContractTemplates/utils/utils";

import IndicatorList from "./components/IndicatorList";

interface FieldIdentifiersModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const FieldIdentifiersModal: React.FC<FieldIdentifiersModalProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const [word, setWord] = useState("");
  const [formatData, setFormatData] = useState<TemplateFieldsIProps>(null);
  const { data } = useGetTemplateFields();

  useEffect(() => {
    if (data) {
      const { default: defaultValue, ...newData } = data;
      setFormatData(formaterData(newData));
    }
  }, [data]);

  const handleWord = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWord(e.target.value);
  };

  const handleClose = () => {
    setWord("");
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      title={t("contractTemplates.identifiers")}
      onCancel={handleClose}
      size={"large"}
      closable
      centered
      destroyOnHidden
      cancelButton={{ children: t("ui.close") }}
    >
      <Input
        value={word}
        name="search"
        onChange={handleWord}
        style={{ width: "100%" }}
      />
      {formatData ? (
        <IndicatorList formatData={formatData} word={word} />
      ) : (
        <Preloader />
      )}
    </Modal>
  );
};

export default FieldIdentifiersModal;
